import { Apple, MonitorDown } from 'lucide-react';
import { PLATFORMS, type Platform } from '@/lib/db';

interface PlatformIconProps {
  platform: Platform;
  className?: string;
}

export function PlatformIcon({ platform, className }: PlatformIconProps) {
  if (platform === PLATFORMS.macos) {
    return <Apple className={className} aria-hidden="true" />;
  }
  return <MonitorDown className={className} aria-hidden="true" />;
}
